import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import AppCard from "../../../components/AppCard";
import CreateApplicationModal from "../../../components/CreateApplicationModal";
import {useEffect} from "react";
import Authorize from "../../../components/Authorize";

export interface ApplicationItemProps {
    id: string;
    name: string;
    apiKey: string;
}

const Overview = (): React.ReactElement => {
    const [open, setOpen] = React.useState(false);
    const [list, setList] = React.useState<ApplicationItemProps[]>([]);

    const fetchList = async () => {
        const result = await fetch("/api/v1/Application", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            }
        });

        if(result.status == 200) return (await result.json()).result;
        else return [];
    }

    useEffect(() => {
        fetchList().then(setList);
    }, []);

    return (
        <>
            <Authorize/>
            <CreateApplicationModal
                show={open}
                handleClose={() => setOpen(false)}
                reFetch={() => fetchList().then(setList)}
            />
            <Container maxWidth="lg">
                <Stack spacing={3}>
                    <Button variant="contained" onClick={() => setOpen(true)}>Create application</Button>
                    <Box sx={{flexGrow: 1}}>
                        <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 2, sm: 8, md: 12}}>
                            {list.map((o, index) => (
                                <Grid item xs={2} sm={4} md={4} key={index}>
                                    <AppCard reFetch={() => fetchList().then(setList)} {...o}/>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Stack>
            </Container>
        </>
    );
};

export default Overview;